// extracted by mini-css-extract-plugin
module.exports = {"root":"CallPromptsHost__root___cwHl6","callPrompt":"CallPromptsHost__callPrompt___DcPCy","callManager":"CallPromptsHost__callManager___iNgbi"};